module.exports = __webpack_public_path__ + "img/white_paper11.a710fee3.png";